import { render, staticRenderFns } from "./st-credits.vue?vue&type=template&id=62c4fb87&"
import script from "./st-credits.vue?vue&type=script&lang=js&"
export * from "./st-credits.vue?vue&type=script&lang=js&"
import style0 from "./st-credits.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports